import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CoordinatingColorsStorageModel } from '../models/coordinating-colors.model';

@Injectable({ providedIn: 'root' })
export class CoordinatingColorsStorageService {
  #httpClient = inject(HttpClient);

  getAllCoordinatingColors(siteId: number): Observable<Record<string, CoordinatingColorsStorageModel[]>> {
    const coordinatingColorsFrontDoorUrl = `/${siteId}-coordinating-colors.json`;
    return this.#httpClient.get<Record<string, CoordinatingColorsStorageModel[]>>(coordinatingColorsFrontDoorUrl);
  }
}
